<div class="other-products">
  <h2 class="other-products__title">
    {{ 'OTHER_PRODUCTS.TITLE' | translate }}
  </h2>

  <div class="other-products__content">
    <div  class="other-products__content__product"
          *ngFor="let product of products">
      <app-product-tile [config]="product"></app-product-tile>
    </div>
  </div>
</div>
